import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import dayjs from 'dayjs'
import styles from './index.module.scss'
import { DatePickerInput } from '../DatePickerInput'
import notify from '../../utilities/notify'

function BlackoutDatesSection ({ form, values }) {
  const [pendingDate, setPendingDate] = useState('')
  const [pendingReason, setPendingReason] = useState('')
  const blackoutDates = values.blackoutDates ?? []

  function addBlackoutDate () {
    if (!pendingDate) return

    if (blackoutDates.some(({ date }) => date === pendingDate)) {
      notify('error', 'This date is already excluded')
      return
    }

    form.change(
      'blackoutDates',
      [...blackoutDates, { date: pendingDate, reason: pendingReason }]
        .sort((a, b) => a.date.localeCompare(b.date))
    )
    setPendingDate('')
    setPendingReason('')
  }

  function removeBlackoutDate (date) {
    form.change(
      'blackoutDates',
      blackoutDates.filter(d => d.date !== date)
    )
  }

  return (
    <>
      <Field name='blackoutDates' subscription={{}} render={() => null} />
      <div className={styles.blackoutDateInput}>
        <div className={styles.blackoutDateFieldsWrapper}>
          <DatePickerInput
            input={{
              name: 'pendingBlackoutDate',
              value: pendingDate,
              onChange: setPendingDate,
              onBlur: () => {}
            }}
            meta={{ touched: false, error: undefined }}
            placeholder='Select Date'
            minDate={dayjs().startOf('day').toDate()}
          />
          <button
            type='button'
            className='dis-btn dis-btn-primary dis-btn-lg'
            onClick={addBlackoutDate}
            disabled={!pendingDate}>
            Add Date
          </button>
        </div>
      </div>

      {blackoutDates.length > 0 && (
        <div className={styles.selectedDates}>
          <p className={styles.selectedDatesHeading}>Selected Dates</p>
          <ul className={styles.blackoutDateList}>
            {blackoutDates.map(({ date, reason }) => (
              <li key={date} className={styles.blackoutDateChip}>
                <span className={styles.blackoutDateChipText}>
                  <span className={styles.blackoutDateChipDate}>{dayjs(date).format('MM/DD/YYYY')}</span>
                  {reason && (
                    <span className={styles.blackoutDateChipReason}>{reason}</span>
                  )}
                </span>
                <button
                  type='button'
                  className={styles.removeDateBtn}
                  onClick={() => removeBlackoutDate(date)}
                  aria-label={`Remove ${dayjs(date).format('MM/DD/YYYY')}`}>
                  <i className='material-icons'>close</i>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

BlackoutDatesSection.propTypes = {
  form: PropTypes.shape({
    change: PropTypes.func.isRequired
  }).isRequired,
  values: PropTypes.shape({
    blackoutDates: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        reason: PropTypes.string
      })
    )
  }).isRequired
}

export default BlackoutDatesSection
